export const PANEL_TYPES = {
  STANDARD: "standard",
  CUSTOM_ICON: "custom_icon",
  CUSTOM_EMOJI: "custom_emoji",
  DOT: "dot",
};
